<template>
  <span class="svg-icon-emoji-tab" :style="iconStyle">
    <svg class="icon-color-1" :style="`width:${width}px; height:${width}px; fill:none;`" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.83325 1.5C5.68575 1.5 2.33325 4.875 2.33325 9C2.33325 10.9891 3.12343 12.8968 4.52995 14.3033C5.22639 14.9997 6.05318 15.5522 6.96313 15.9291C7.87307 16.306 8.84834 16.5 9.83325 16.5C11.8224 16.5 13.73 15.7098 15.1366 14.3033C16.5431 12.8968 17.3333 10.9891 17.3333 9C17.3333 8.01509 17.1393 7.03982 16.7623 6.12987C16.3854 5.21993 15.833 4.39314 15.1366 3.6967C14.4401 3.00026 13.6133 2.44781 12.7034 2.0709C11.7934 1.69399 10.8182 1.5 9.83325 1.5ZM12.4583 6C12.7566 6 13.0428 6.11853 13.2537 6.3295C13.4647 6.54048 13.5833 6.82663 13.5833 7.125C13.5833 7.42337 13.4647 7.70952 13.2537 7.9205C13.0428 8.13147 12.7566 8.25 12.4583 8.25C12.1599 8.25 11.8737 8.13147 11.6628 7.9205C11.4518 7.70952 11.3333 7.42337 11.3333 7.125C11.3333 6.82663 11.4518 6.54048 11.6628 6.3295C11.8737 6.11853 12.1599 6 12.4583 6ZM7.20825 6C7.50662 6 7.79277 6.11853 8.00375 6.3295C8.21473 6.54048 8.33325 6.82663 8.33325 7.125C8.33325 7.42337 8.21473 7.70952 8.00375 7.9205C7.79277 8.13147 7.50662 8.25 7.20825 8.25C6.90988 8.25 6.62373 8.13147 6.41276 7.9205C6.20178 7.70952 6.08325 7.42337 6.08325 7.125C6.08325 6.82663 6.20178 6.54048 6.41276 6.3295C6.62373 6.11853 6.90988 6 7.20825 6ZM9.83325 13.125C8.08575 13.125 6.60075 12.03 6.00075 10.5H13.6658C13.0583 12.03 11.5808 13.125 9.83325 13.125Z" fill="#212121"/>
    </svg>
  </span>
</template>

<script>
import { computed } from 'vue'
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  },

  computed: {
    iconStyle () {
      return {
        '--iconColor': this.color,
        'width': `${this.width}px`,
        'height': `${this.width}px`,
        'fill': 'none'
      }
    }
  }
}
</script>

<style lang="scss">
  .svg-icon-emoji-tab {
    display: flex;
    justify-content: left;
    align-items: center;

    path {
      fill: var(--iconColor)
    }
  }
</style>
